@let source = candidate().source;
<div class="channel-candidate">
  <span class="channel-candidate__title">{{ title() }}</span>
  <dl class="channel-candidate__facts">
    <div class="channel-candidate__fact">
      <dt>{{ 'installations.dataSources.serial' | translate }}</dt>
      <dd>{{ source.serial ?? '–' }}</dd>
    </div>
    @if (source.label) {
      <div class="channel-candidate__fact">
        <dt>{{ 'installations.dataSources.channels.label' | translate }}</dt>
        <dd>{{ source.label }}</dd>
      </div>
    }
    <div class="channel-candidate__fact">
      <dt>{{ 'installations.editor.candidate.rule' | translate }}</dt>
      <dd>{{ candidate().channelRule }}</dd>
    </div>
    <div class="channel-candidate__fact">
      <dt>{{ 'installations.editor.candidate.net' | translate }}</dt>
      <dd>{{ (candidate().isNet ? 'general.yes' : 'general.no') | translate }}</dd>
    </div>
  </dl>
  @if (current()) {
    <span class="channel-candidate__note">{{
      'installations.editor.candidate.current' | translate
    }}</span>
  }
  @if (heldElsewhere()) {
    <span class="channel-candidate__note channel-candidate__note--warning">
      @if (candidate().inUseBy; as holder) {
        {{
          'installations.editor.candidate.inUseBy'
            | translate: { point: holder.pointName, installation: holder.installationName }
        }}
      } @else {
        {{ 'installations.editor.candidate.inUseHidden' | translate }}
      }
    </span>
  }
  @if (otherInstallationNames(); as names) {
    <span class="channel-candidate__note" data-testid="also-feeds">
      {{ 'installations.editor.candidate.alsoFeeds' | translate: { installations: names } }}
    </span>
  }
  @if (sharedWith().length) {
    <span class="channel-candidate__note">
      {{
        'installations.editor.candidate.sharedWith' | translate: { points: sharedWith().join(', ') }
      }}
    </span>
  }
  @if (error(); as messageKey) {
    <span class="channel-candidate__error text-text-error" role="alert">{{
      messageKey | translate
    }}</span>
  }
</div>
